<template>
<div>
  <!-- <h4>Transit Mode</h4>
  <p>You must pick at least one transit mode</p> -->
  <div class="btn-group btn-group-toggle" adata-toggle="buttons">
    <label v-for="(mode, index) in modes"
    			 :class="{ btn: true, active: mode.selected, 'text-dark': true }"
    			 :key="mode.value">
      <span :class="mode.icon_class + ((mode.selected) ? '' : '-gray')"></span>
      {{ mode.label }}
      <input type="checkbox"
      			 name="options"
      			 autocomplete="off"
      			 @click="setModesHandler(index)">
      <span class=""></span>

    </label>
  </div>
</div>
</template>

<script>

export default {
  name: 'mode-selections',
  data () {
    return {
    	// https://developers.google.com/maps/documentation/directions/intro#TravelModes
    	modes: [
    		{ value: 'lightrail', label: 'Light Rail', transit: true, selected: false, icon_class: 'icon-icon-light-rail', googleKey: 'TRAM', otpKey: 'TRAM,SUBWAY,RAIL' },
    		{ value: 'bus', label: 'Bus', transit: true, selected: false, icon_class: 'icon-icon-bus', googleKey: 'BUS', otpKey: 'BUS' },
    		{ value: 'parkride', label: 'Park & Ride', transit: true, selected: false, icon_class: 'icon-icon-park-and-ride', googleKey: '-', otpKey: 'CAR' },
    		// { value: 'bicycling', label: 'Cycle', transit: false, selected: false, icon_class: 'icon-icon-bike', googleKey: 'BICYCLING', otpKey: 'BICYCLE' }
    	]
    }
  },
  watch: {
    tripOptions (options) {
      if (options.mode === null) {
        this.initModes()
      }
    }
  },
  computed: {
    tripOptions () {
      return this.$store.getters['tripPlanner/inputs'].options;
    },
  },
  methods: {
  	setModesHandler (index) {
  		this.modes[index].selected = !this.modes[index].selected
  		this.updateStore()
  	},
  	updateStore () {
      let modesList = [...this.modes] // clone data array
      // modesList.push({ selected: true, otpKey: 'WALK' })

      let selectedModes = modesList
                            .filter(x => x.selected)
                            .map(x => x.otpKey)
                            .join(",")
      if (selectedModes !== 'BICYCLE') {
        selectedModes += ',WALK'
      }

      // let tripOptionsNew = Object.assign({}, this.tripOptions)
      let tripOptionsNew = JSON.parse(JSON.stringify(this.tripOptions))

      tripOptionsNew.mode = selectedModes
      this.$store.commit('tripPlanner/SET_TRIP_OPTIONS', tripOptionsNew);

  	},
    initModes () {
      let noModesSelected = true
      this.modes.forEach((x, i) => {
        if (this.$route.query.mode) {
          if (this.$route.query.mode.toLowerCase().includes(x.value.toLowerCase())) {
            this.modes[i].selected = true
            noModesSelected = false
          }
        }
      })

      // if no modes selected then select all by default
      if (noModesSelected) {
        this.modes.forEach((x, i) => {
          if (this.modes[i].value === 'lightrail' || this.modes[i].value === 'bus') {
            this.modes[i].selected = true
          }
        })
      }
    }
  },
  mounted () {
    this.initModes()
  }
}
</script>

<style lang="scss">
.btn-group-toggle label {
	background-color: #fff;
	border:solid 1px #ccc;
	font-size: 12px;
  opacity: 0.7;
}
.btn-group-toggle label.active {
	// background-color: #eee;
  opacity: 1;
}
.btn-group-toggle [class^="icon-"] {
	display: block;
	font-size: 26px;
}

.btn-group-toggle .btn {
  min-width: 1rem;
}

@media (max-width: 640px) {
  .btn-group-toggle .btn {
    min-width: 1rem;
    padding: .6em 1em;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ModeSelections.vue